import { GlTooltipDirective, GlAvatarsInline, GlAvatar, GlAvatarLink } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import ItemMilestone from '../../../issuable/components/issue_milestone.vue?vue3';
import { s__, sprintf } from '~/locale';
import { findAssigneesWidget, findMilestoneWidget, getDisplayReference } from '../../utils.js?vue3';
export default {
    name: 'WorkItemRelationshipPopoverMetadata',
    components: {
        ItemMilestone,
        GlAvatar,
        GlAvatarLink,
        GlAvatarsInline
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        workItem: {
            type: Object,
            required: true
        },
        workItemFullPath: {
            type: String,
            required: true
        }
    },
    assigneesDisplayLimit: 3,
    computed: {
        workItemAssignees () {
            return findAssigneesWidget(this.workItem)?.assignees?.nodes || [];
        },
        workItemMilestone () {
            return this.workItem?.features?.milestone?.milestone || findMilestoneWidget(this.workItem)?.milestone;
        },
        fullReference () {
            return getDisplayReference(this.workItemFullPath, this.workItem.reference);
        },
        directNamespaceReference () {
            return this.fullReference.split('/').slice(-1)[0];
        },
        assigneesCollapsedTooltip () {
            if (this.workItemAssignees.length > this.$options.assigneesDisplayLimit) {
                return sprintf(s__('WorkItem|%{count} more assignees'), {
                    count: this.workItemAssignees.length - this.$options.assigneesDisplayLimit
                });
            }
            return '';
        }
    }
};
